import { ReturnPolicyType } from "@redotech/crdb-enums/returns/return-policy-type";
import { ReturnPolicySnapshotSettingsSchema } from "@redotech/redo-return-core-common/return-policy/snapshot-settings";
import { returnPolicyIdFormat } from "@redotech/redo-return-id";
import * as z from "zod";

/** One return policy as the editor opens it: its draft, or its published version when it has no draft. */
export const getReturnPolicy = {
  name: "getReturnPolicy" as const,
  input: z.object({ id: returnPolicyIdFormat.schema }),
  output: z.object({
    id: returnPolicyIdFormat.schema,
    name: z.string(),
    type: z.enum(ReturnPolicyType),
    isLive: z.boolean(),
    hasDraft: z.boolean(),
    publishedAt: z.date().nullable(),
    settings: ReturnPolicySnapshotSettingsSchema,
  }),
};
